// extracted by mini-css-extract-plugin
export default {"root":"olH1Fcpy8jwJ44YK0Ovl","editable":"QhmHOTntk8KrBDW1c5_z","tools":"ZWMQg_e_8hZ2vlnfHp6Q","icon":"iYqRHPFVM1U5ZOYkt0VA"};